import axios from "axios";
import { API_BASE_URL } from "../utils/api";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 50000,
  withCredentials: true,
});

export default axiosInstance;
